import React from 'react';

import { FormikHelpers } from 'formik';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { addRouteAxis, addRouteAxisStops, successAlert } from 'actions';
import { axisPriceAllowed } from 'app/fare-products/shared/fareConstraints';
import { AxisFormState } from 'app/operations/routes/axis-helpers';

import { AxisForm } from './axis-form';

const initialState: AxisFormState = {
  ar_name: '',
  en_name: '',
  cash_price: '',
  card_price: '',
  code: '',
  stops: [],
};

interface AddAxisProps {
  setOpen: (newState: boolean) => void;
}

const AddAxis: React.FC<AddAxisProps> = ({ setOpen }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const match = useRouteMatch<{ id: string }>();

  const routeId = match.params.id;

  const handleSubmit = async (
    values: AxisFormState,
    { setSubmitting }: FormikHelpers<AxisFormState>
  ) => {
    setSubmitting(true);
    try {
      // A new axis is not discount-free: an assignment with no routes applies
      // organisation-wide, so it reaches this axis the moment it exists. The
      // route alone determines that, which is why the check takes route_id.
      const priceOk = await axisPriceAllowed({
        routeId,
        cashPrice: values.cash_price,
        cardPrice: values.card_price,
        intl,
      });

      if (!priceOk) return;

      const res: any = await Promise.resolve(
        dispatch(
          addRouteAxis({
            ...values,
            route_id: routeId,
          })
        )
      );

      const axisId = res.value.data.response.id;

      await Promise.resolve(
        dispatch(addRouteAxisStops(axisId, routeId, values.stops))
      );

      setOpen(false);

      dispatch(successAlert(intl.formatMessage({ id: 'successAddAxis' })));
    } finally {
      setSubmitting(false);
    }
  };

  return <AxisForm {...{ initialState, handleSubmit, setOpen }} />;
};

export { AddAxis };
